import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import Chart from "react-apexcharts";
import Grid from "@material-ui/core/Grid";
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import ConsumptionsList from "./ConsumptionsList";
import {FormatNumber, GetNameMonth} from "../../helpers/Helpers";

class Consumptions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            consumptionsList: [],
            series: [],
            options: {
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Kwh / m'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `${FormatNumber.new(val)} Kwh / m`
                        }
                    }
                }
            },
        };
    }

    async componentDidMount() {
        await this.getConsumptions();
    }

    getConsumptions = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlSeguridad}/getVConsumoWeb/${account.cuentaCodigo}`);
        if (data.cod === '1') {
            this.setState({
                consumptionsList: data.V_consumo_WEB,
            });
            this.setDataChart(data.V_consumo_WEB);
        }
    }

    setDataChart = (data) => {

        // Configuro la data
        let dataSeriesActiva = [];
        let dataSeriesReactiva = [];
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];
            dataSeriesActiva.push(obj.ENERGIA_ACTIVA);
            dataSeriesReactiva.push(obj.ENERGIA_REACTIVA);
        }

        // Configuro los labels
        let categories = [];
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];
            const val = `${obj.ANO} - ${GetNameMonth(obj.MES)}`;
            categories.push(val);
        }

        // Se asignan al estado del diagrama de barras
        this.setState({
            series: [
                {
                    name: 'Activa',
                    data: dataSeriesActiva
                },
                {
                    name: 'Reactiva',
                    data: dataSeriesReactiva
                }
            ],
            options: {
                xaxis: {
                    categories: categories
                }
            }
        });
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Consumos'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Consumos</span>
                </h2>

                <Grid container>
                    <Grid item xs={7} style={{padding: '20px'}}>
                        <ConsumptionsList data={this.state.consumptionsList}/>
                    </Grid>
                    <Grid item xs={5} style={{padding: '20px'}}>
                        <Chart options={this.state.options} series={this.state.series} type="bar" height={300}/>
                    </Grid>
                </Grid>

            </div>
        );
    }
}

export default withRouter(Consumptions)